/** @jsx h */
import { h, render } from 'preact';
import App from './App';
import Model from './model';

const model = new Model();

if (navigator.serviceWorker) {
  navigator.serviceWorker.register('./worker.js');
}

render(<App model={model} />, document.body);
